// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg-custom-gray[data-v-b0e2657c] {\n  background-color: #F7F7F7;\n}", ""]);
// Exports
module.exports = exports;
